import React from "react";
const IconTransportTrain = (props) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 32 32",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.23 3c1.537 0 2.926.92 3.53 2.338l.296.692A24.318 24.318 0 0 1 26.074 22.2a3.845 3.845 0 0 1-3.46 2.792l1.28 2.56a1 1 0 0 1-1.788.894L20.382 25h-8.765l-1.723 3.447a1 1 0 0 1-1.788-.894l1.28-2.56a3.843 3.843 0 0 1-3.46-2.792A24.306 24.306 0 0 1 6.945 6.028l.294-.69A3.84 3.84 0 0 1 10.77 3h10.46zm2.311 4.62l-.04.196c-.98 4.723-3.904 8.184-7.5 8.184-3.648 0-6.602-3.557-7.542-8.38a22.305 22.305 0 0 0-.609 14.035A1.842 1.842 0 0 0 9.62 23H22.38c.82 0 1.542-.548 1.77-1.346a22.319 22.319 0 0 0-.61-14.034zM11.5 18.375a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25zm9 0a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25zM21.23 5H10.77c-.21 0-.413.036-.605.103l-.007-.144C10.368 10.097 13.023 14 16 14c2.948 0 5.583-3.83 5.835-8.895A1.808 1.808 0 0 0 21.23 5z"
}));
var IconTransportTrain_default = IconTransportTrain;
export {
  IconTransportTrain_default as default
};
